import { Link } from "react-router-dom";
import { Users } from "lucide-react";
import { Button } from "../../components/ui/button";

/** Shown instead of a create form when a visitor (non-member) opens an "add" page. */
export function MembersOnlyNotice({ locationCode }: { locationCode: string | null }) {
  return (
    <div className="mx-auto max-w-md rounded-lg border bg-card p-6 text-center">
      <Users className="mx-auto mb-3 h-8 w-8 text-muted-foreground" />
      <h2 className="text-lg font-semibold">Only members can post here</h2>
      <p className="mt-1 text-sm text-muted-foreground">
        You're visiting this location. Become a member to post and to see members-only content.
      </p>
      {locationCode && (
        <Button asChild className="mt-4">
          <Link to={`/locations/${locationCode}`}>Become a member</Link>
        </Button>
      )}
    </div>
  );
}
